import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Success = () => {
  return <div className="min-h-screen bg-gradient-to-b from-[#f8faff] to-[#f0f5ff] flex flex-col items-center justify-center px-4" data-id="element-953">
      <motion.div className="bg-white rounded-xl shadow-lg p-10 max-w-md w-full text-center" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} data-id="element-954">
        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 20,
        delay: 0.2
      }} className="mx-auto mb-6 bg-green-100 rounded-full p-3 w-20 h-20 flex items-center justify-center" data-id="element-955">
          <CheckCircleIcon className="h-12 w-12 text-green-500" data-id="element-956" />
        </motion.div>
        <h1 className="text-3xl font-bold text-[#0B1220] mb-4" data-id="element-957">Success!</h1>
        <p className="text-[#5A6376] mb-6" data-id="element-958">
          Your action has been completed successfully.
        </p>
        <motion.div whileHover={{
        y: -2
      }} whileTap={{
        scale: 0.98
      }} data-id="element-959">
          <Link to="/" className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-[#2E6BFF] to-[#36D1DC] text-white font-medium rounded-full shadow-md hover:shadow-lg transition-all duration-200" data-id="element-960">
            Return Home
          </Link>
        </motion.div>
      </motion.div>
    </div>;
};